<div class="error-page-container" [class.rtl]="currentLang() === 'he'">
    <div class="error-content">
        <div class="error-icon" [ngSwitch]="errorType()">
            <!-- Expired Icon -->
            <svg *ngSwitchCase="'expired'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
            </svg>

            <!-- Completed Icon -->
            <svg *ngSwitchCase="'completed'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>

            <!-- Not Found Icon -->
            <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
        </div>
        <h1 class="error-title">
            {{ currentLang() === 'he' ? currentError.title.he : currentError.title.en }}
        </h1>
        <p class="error-message">
            {{ currentLang() === 'he' ? currentError.message.he : currentError.message.en }}
        </p>
        <button class="btn-back-to-main" (click)="goToMain()">
            {{ currentLang() === 'he' ? 'חזרה לדף הראשי' : 'Back to Main Page' }}
        </button>
    </div>
</div>